import React, { useState } from 'react';
import { formatLinkBlockToUrl } from '$utilities/data';
import { Button } from '$partials/ui';
import { GeneralEnquiryDialog } from '$partials/global';
import IconChevron from '$partials/icons/icon-chevron';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').CtaBanner}
 */

const CtaBanner = ({
    heading,
    body,
    ctaLabel,
    ctaLink,
    opensDialog,
    defaultOffice,
}) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    return (
        <>
            <div className='module-cta-banner theme-light-alt bg-main-background relative z-10'>
                <div className='layout-container layout-site-outer-padding py-24 sm:py-48 md:py-64'>
                    <div className='flex flex-col gap-y-12 col-wrapper'>
                        {heading &&
                            <h2 className='w-full sm:w-8/12 md:w-5/12 col-padding type-style-2 text-main-text-primary'>
                                {heading}
                            </h2>
                        }
                        {body &&
                            <p className='w-full sm:w-8/12 md:w-5/12 col-padding type-style-body-r text-main-text-primary'>
                                {body}
                            </p>
                        }

                        {ctaLink && ctaLabel && (
                            <div className='col-padding'>
                                <Button
                                    as='a'
                                    className='w-max mt-16 cursor-pointer flex flex-row items-center button-brand-filled py-13 px-16 rounded type-style-eyebrow'
                                    href={formatLinkBlockToUrl(ctaLink) || '#'}>
                                    {ctaLabel}
                                    <IconChevron className='inline-block ml-10 -rotate-90' />
                                </Button>
                            </div>
                        )}
                        {!(ctaLink && ctaLabel) && opensDialog && (
                            <div className='col-padding'>
                                <Button
                                    as='button'
                                    className='w-max mt-16 cursor-pointer flex flex-row items-center button-brand-filled py-13 px-16 rounded  type-style-eyebrow'
                                    onClick={() => setIsDialogOpen(true)}>
                                    Get in Touch
                                    <IconChevron className='inline-block ml-10 -rotate-90' />
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {isDialogOpen && (
                <GeneralEnquiryDialog
                    closeDialog={() => setIsDialogOpen(false)}
                    isOpen={isDialogOpen}
                    defaultOffice={defaultOffice}/>
            )}
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default CtaBanner;
